import { action, computed, makeObservable, observable } from 'mobx';

export enum DashboardSection {
  EAR = 'ear',
  KPI = 'kpi',
  MOREMCR = 'moremcr',
}

export class Sections {
  readonly defaultSectionsState: Record<DashboardSection, boolean> = {
    [DashboardSection.KPI]: true,
    [DashboardSection.EAR]: false,
    [DashboardSection.MOREMCR]: false,
  };
  @observable sectionsHidden: Record<DashboardSection, boolean> =
    { ...this.defaultSectionsState };
  constructor() {
    makeObservable(this);
  }

  @computed get isCollapseAll() {
    return Object.values(this.sectionsHidden).every(element => element);
  }

  @action collapseAll = (force?: boolean) => {
    if (force !== undefined) {
      (Object.keys(this.sectionsHidden) as DashboardSection[]).forEach(key => {
        this.sectionsHidden[key] = force;
      });
    } else {
      (Object.keys(this.sectionsHidden) as DashboardSection[]).forEach(key => {
        this.sectionsHidden[key] = !this.sectionsHidden[key];
      });
    }
  };

  @action toggleSection = (name: DashboardSection, force?: boolean) => {
    if (force !== undefined) {
      this.sectionsHidden[name] = force;
    } else {
      this.sectionsHidden[name] = !this.sectionsHidden[name];
    }
  };
}
